// Rich-text length cap, shared by every RTE-backed body in the admin.
//
// [공통] 00_입력검증표준 §3 puts rich text outside the free-text class table and
// names the two fields it covers explicitly: "리치텍스트(공지 내용·약관 본문)는
// 클래스 예외 — 최대 20,000자 (HTML 태그 포함, 확정 2026-07-10)". PRD 13 §4.2
// (공지) and PRD 14 §4.2 (약관, `1~20,000자(HTML 포함)`) both defer to it.
//
// The cap counts the RAW HTML — tags included — not the stripped text, because
// that is what the server stores and what §3 says. Measuring the visible text
// instead would let a heavily formatted body past the client and fail on save.
//
// Lives in shared/ rather than in one feature so the two screens cannot drift:
// SHCT-703 existed precisely because 약관 never got the rule that 공지 already had.

export const RICH_TEXT_MAX = 20_000;

export function isRichTextTooLong(html: string | undefined): boolean {
  return (html ?? '').length > RICH_TEXT_MAX;
}
